"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParamExtractingStrategies = void 0;
var tslib_1 = require("tslib");
var DEFAULT_LOCALE = 'en';
var getSaleType = function (saleType, daysLeft) {
    if (daysLeft === void 0) { daysLeft = 0; }
    if (saleType === "Seasonal" /* SEASONAL */ && daysLeft === 1) {
        return "lastSaleDay" /* LAST_SALE_DAY */;
    }
    if (saleType === "Seasonal" /* SEASONAL */) {
        return "sale" /* SALE */;
    }
    if (saleType === "None" /* NO_SALE */) {
        return "None" /* NO_SALE */;
    }
    return saleType;
};
exports.getParamExtractingStrategies = function (context, path) {
    var locale = context.locale, saleType = context.saleType, daysLeft = context.daysLeft;
    var sale = getSaleType(saleType, daysLeft);
    if (sale === "lastSaleDay" /* LAST_SALE_DAY */) {
        return [
            tslib_1.__spreadArrays([locale, "lastSaleDay" /* LAST_SALE_DAY */], path),
            tslib_1.__spreadArrays([locale, "sale" /* SALE */], path),
            tslib_1.__spreadArrays([locale], path),
            tslib_1.__spreadArrays([DEFAULT_LOCALE, "lastSaleDay" /* LAST_SALE_DAY */], path),
            tslib_1.__spreadArrays([DEFAULT_LOCALE, "sale" /* SALE */], path),
            tslib_1.__spreadArrays([DEFAULT_LOCALE], path),
            tslib_1.__spreadArrays(path),
        ];
    }
    if (sale !== "None" /* NO_SALE */) {
        return [
            tslib_1.__spreadArrays([locale, sale], path),
            tslib_1.__spreadArrays([locale], path),
            tslib_1.__spreadArrays([DEFAULT_LOCALE, sale], path),
            tslib_1.__spreadArrays([DEFAULT_LOCALE], path),
            tslib_1.__spreadArrays(path),
        ];
    }
    return [tslib_1.__spreadArrays([locale], path), tslib_1.__spreadArrays([DEFAULT_LOCALE], path), tslib_1.__spreadArrays(path)];
};
//# sourceMappingURL=FallbackMapper.js.map